module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="block">\n  <div class="filter-hook"></div>\n  <div id="datatable-hook"></div>\n  <div class="page-hook"></div>\n</div>\n\n<div class="actions">\n  <button type="button" class="button" id="btn-import">Import Selected</button>\n  <button type="button" class="button button-secondary import-all">\n    Import 100\n  </button>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/contact/index.html
// module id = 229
// module chunks = 0